import { CREATE_MESSAGE, CLEAR_MESSAGES } from '../actions/types';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case CREATE_MESSAGE:
      return (state = action.payload);
    case CLEAR_MESSAGES:
      return initialState;
    default:
      return state;
  }
}
